<template>
	<a-modal :title="isUpdate ? '修改任务' : '新增任务'" :width="640" :visible="visible" :confirmLoading="false"
		:maskClosable="false" @ok="handleOk" @cancel="handleCancel">
		<a-spin :spinning="loading">
			<a-form-model ref="adminForm" :model="form" :label-col="{span:6}" :wrapper-col="{span:14}" autoComplete="off">
				<a-form-model-item v-show="false" label="ID" prop="id">
					<a-input type="hidden" v-model.number="form.id" />
				</a-form-model-item>

				<a-form-model-item label="类型" prop="type"
					:rules="typeRules">
					<a-select v-model="form.type" style="width:100px" placeholder="请选择" :disabled="isUpdate">
						<a-select-option value="NEWBIE">新手</a-select-option>
						<a-select-option value="DAILY">日常</a-select-option>
					</a-select>
				</a-form-model-item>
				<a-form-model-item label="受众" prop="sex"
					:rules="sexRules">
					<a-select v-model="form.sex" style="width:100px" placeholder="请选择" :disabled="isUpdate">
						<a-select-option value="MALE">男</a-select-option>
						<a-select-option value="FEMALE">女</a-select-option>
					</a-select>
				</a-form-model-item>

				<a-form-model-item label="名称" prop="name"
					:rules="nameRules">
					<a-input v-model="form.name" :disabled="isUpdate" />
				</a-form-model-item>
				<a-form-model-item label="标识" prop="ident"
					:rules="identRules">
					<a-input v-model="form.ident" :disabled="isUpdate" />
				</a-form-model-item>

				<a-form-model-item label="奖励" prop="reward"
					:rules="[{ required: true, message: '必填，不能为空', trigger: 'change' }]">
					<a-input-number v-model="form.reward" :min="0" style="width: 90px;" />
					<span v-if="rewardUnitLabel" class="tip">{{ rewardUnitLabel }}</span>
				</a-form-model-item>
				<a-form-model-item label="排序" prop="seq"
					:rules="[{ required: true, message: '必填，不能为空', trigger: 'change' }]">
					<a-input-number v-model="form.seq" />
				</a-form-model-item>
				<a-form-model-item label="描述" prop="depict">
					<a-textarea v-model="form.depict" :auto-size="{minRows:2, maxRows:5}" :disabled="isUpdate" />
				</a-form-model-item>
			</a-form-model>
		</a-spin>
	</a-modal>
</template>

<script>
	import pick from 'lodash.pick';
	import {
		taskNameIsExist
	} from '@/api/content/task.js';

	const fields = ['id', 'name', 'ident', 'depict', 'type', 'sex', 'reward', 'seq'];

	function emptyForm() {
		return {
			id: 0,
			name: '',
			ident: '',
			depict: '',
			type: undefined,
			sex: undefined,
			reward: undefined,
			seq: 50
		};
	}

	export default {
		props: {
			visible: {
				type: Boolean,
				required: true
			},
			loading: {
				type: Boolean,
				default: () => false
			},
			model: {
				type: Object,
				default: () => null
			}
		},
		data() {
			return {
				form: emptyForm(),
			}
		},
		created() {
			this.unwatch = this.$watch('model', (newVal) => {
				if (!newVal) {
					this.initForm();
					return;
				}
				this.$nextTick(() => {
					const base = pick(newVal, fields);
					if (base.sex === undefined && newVal.audience !== undefined) {
						base.sex = newVal.audience;
					}
					this.form = { ...emptyForm(), ...base };
					if (this.form.seq === undefined || this.form.seq === null) {
						this.form.seq = 50;
					}
					if (this.$refs.adminForm) {
						this.$refs.adminForm.clearValidate();
					}
				});
			}, {
				immediate: true
			});
		},
		computed: {
			isUpdate: function() {
				return this.model && this.model.id > 0 ? true : false;
			},
			typeRules() {
				if (this.isUpdate) return [];
				return [{ required: true, message: '必填，不能为空', trigger: 'change' }];
			},
			sexRules() {
				if (this.isUpdate) return [];
				return [{ required: true, message: '必填，不能为空', trigger: 'change' }];
			},
			nameRules() {
				if (this.isUpdate) return [];
				return [
					{ required: true, message: '必填，不能为空', trigger: 'blur' },
					{ validator: this.isExistName, trigger: 'blur' }
				];
			},
			identRules() {
				if (this.isUpdate) return [];
				return [{ required: true, message: '必填，不能为空', trigger: 'blur' }];
			},
			rewardUnitLabel() {
				if (this.form.sex == 'MALE') {
					return '金币';
				}
				if (this.form.sex == 'FEMALE') {
					return '积分';
				}
				return '';
			}
		},
		methods: {
			initForm() {
				this.form = emptyForm();
				this.$nextTick(() => {
					if (this.$refs.adminForm) {
						this.$refs.adminForm.clearValidate();
					}
				});
			},
			handleOk() {
				this.$emit('ok');
			},
			handleCancel() {
				this.$emit('cancel');
			},
			isExistName(rule, value, callback) {
				if (value === undefined || value === '' || (this.model && this.model.name === value)) {
					callback();
					return;
				}
				taskNameIsExist(value).then(res => {
					if (res.data) {
						callback(new Error('任务名称已存在'));
					} else {
						callback();
					}
				}).catch(() => {
					callback();
				});
			},
		}
	}
</script>

<style scoped>
	.tip{
		margin-left: 10px;
		color: #acacac;
	}

	.ant-input-number-handler-wrap :deep(.ant-input-number-handler-wrap) {
		display: none;
	}
</style>
